import { defineStore } from "pinia";
import Services from '@/services/sutting/housingTypeServices'
import { mapList, mapHousingType } from '@/helpers/mapFuncs'

export const useHousingTypeStore = defineStore("housingType", {
persist: true,
state:()=>({
    housingType: {},
    housingTypes: [],
}),
getters : {
    getHousingType() {
        return mapHousingType(this.housingType)
    },
    getHousingTypes() {
        return this.housingTypes.map(mapHousingType)
    },
    getHousingTypesList() {
        return this.housingTypes.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setHousingType(housingType) {
        this.housingType = housingType
    },
    setHousingTypes(housingTypes) {
        this.housingTypes = housingTypes
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setHousingType(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setHousingTypes(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.housingTypes.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.housingTypes[this.housingTypes.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.housingTypes = this.housingTypes.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
